import { Component, OnInit, ViewChild, ElementRef } from "@angular/core";
import { AlertController, NavController, ModalController, ToastController } from '@ionic/angular';
import { UtilService } from '../../../service/util.service';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { UserProfile } from '../../../models/user-profile.model';
import { Storage } from '@ionic/storage';
import { UserData } from '../../../providers/user-data';
import { ProductRequestService } from '../product-request.service';
import { ProductRequestBundle } from '../../../models/product-request-bundle.model';
import { FindProductComponent } from '../../../component/find-product/find-product.component';
import { Router } from '@angular/router';
import { RoleAccess } from '../../../models/role-access.model';

import * as XLSX from "xlsx";

class Product {
  public id: string;
  public product_name: string;
}

@Component({
  selector: "app-product-request-create",
  templateUrl: "./product-request-create.page.html",
  styleUrls: ["./product-request-create.page.scss"],
})
export class ProductRequestCreatePage implements OnInit {
  @ViewChild("fileInput", { static: false }) fileInput: ElementRef;

  token: any;
  productSearch: Product[];
  productList: Product[];
  userProfile: UserProfile = new UserProfile();
  counterList: any[] = [];
  warehouseList: any[] = [];
  unitType: any[] = ["PIECES"];

  formProductRequestCreate: FormGroup;
  productRequestId: any;

  productRequestDetailList: any[] = [];

  roleAccess = new RoleAccess();
  warehouseId: any = "";
  counterId: any = "";
  counterCode:any="";
  warehouseListShow: any[] = [];
  proposalNumber:any="";
  proposalDesc:any='';
  proposalStartDate:any='';
  proposalEndDate :any='';
  selectedProposal:any[]=[];
  proposalList:any[]=[];
  usedProposalList:any=[]=[];
  warehouseType:string='R';
  productPriceGroup:any[]=[];
  constructor(
    private fb: FormBuilder,
    private utilService: UtilService,
    private alertController: AlertController,
    private navCtrl: NavController,
    private toastCtrl: ToastController,
    private storage: Storage,
    private userData: UserData,
    private modalController: ModalController,
    private requestService: ProductRequestService,
    private router: Router
  ) {}

  ngOnInit() {
    this.productRequestDetailList = [];
    this.buildFormProductRequest();

    Promise.all([
      this.storage.get("user_token"),
      this.storage.get("user_profile"),
      this.storage.get("user_menu_access"),
    ]).then(([token, profile, access]) => {
      if (token) {
        this.token = token;
        this.userProfile = new UserProfile(profile);
        this.roleAccess = this.userData.checkAccess(
          this.router.url,
          access,
          this.userProfile
        );
        if (!this.roleAccess || this.roleAccess.create != "1") {
          this.toastCtrl
            .create({
              duration: 2000,
              message: "You Are Not Allowed to Access this Page",
            })
            .then((t) => t.present());
          this.navCtrl.navigateForward(["/"]);
        } else {
          this.getAllProduct();
        }
      } else {
        this.toastCtrl
          .create({
            duration: 2000,
            message: "Silahkan login terlebih dahulu.",
          })
          .then((t) => t.present());
        this.navCtrl.navigateForward(["/login"]);
      }
    });
  }

  ionViewWillEnter() {
    this.proposalNumber = '';
    this.proposalDesc = '';
    this.proposalStartDate = '';
    this.proposalEndDate = '';
    this.productRequestDetailList = [];
  }
  getAllProduct() {
    this.utilService.loadingPresent("Harap tunggu...").then(() => {
      this.requestService.getProduct({ token: this.token }).subscribe(
        (response) => {
          if (response.status.code === 200) {
            this.productList = response.results;
          }

          this.getProductRequestCreateData();
        },
        () => {
          this.utilService.loadingDismiss();
          this.toastCtrl
            .create({ duration: 2000, message: "Gagal terhubung ke server" })
            .then((t) => t.present());
        }
      );
    });
  }

  getProductRequestCreateData() {
    let options = {
      token: this.token,
      counter_id:
        this.userProfile.counter_id !== 0
          ? this.userProfile.counter_id
          : this.userProfile.counter_id_list,
    };

    this.requestService.getRequestforCreate(options).subscribe(
      (response) => {
        this.utilService.loadingDismiss();
        if (response.status.code === 200) {
          this.counterList = response.results.counter_data;
          this.warehouseList = response.results.warehouse_data;
          this.warehouseListShow = this.warehouseList;
          this.usedProposalList = response.results.used_proposal;
          this.buildFormProductRequest();
        }
      },
      () => {
        this.utilService.loadingDismiss();
        this.toastCtrl
          .create({ duration: 2000, message: "Gagal terhubung ke server" })
          .then((t) => t.present());
      }
    );
  }

  buildFormProductRequest() {
    let newDate = new Date();
    let convertDate = this.utilService.convertDate(newDate);
    let todayDate = convertDate.years + "-" + convertDate.months + "-" + convertDate.dates;

    this.formProductRequestCreate = this.fb.group({
      docDate: [todayDate, Validators.required],
      needDate: [todayDate, Validators.required],
      counterId: [
        this.counterId != "" ? parseInt(this.counterId) : null,
        Validators.required,
      ],
      warehouseId: [
        this.warehouseId != "" ? parseInt(this.warehouseId) : null,
        Validators.required,
      ],
      proposalNumber:[null],
      description: [null, Validators.required],
    });
  }

  async inputBundle() {
    const checkReguler = this.productRequestDetailList.find(
      x => x.product_type === 'R'
    );

    if (checkReguler) {
      this.saveTransaction();
      return;
    }
    this.customAlert('Produk Reguler Belum Ada','Minimal harus ada 1 produk reguler');
  }
  saveTransaction() {
    this.utilService.loadingPresent("Harap tunggu...").then(() => {
      const formProductRequest = this.formProductRequestCreate.value;
      let counterId = this.counterId;
      let warehouseId = this.warehouseId;
      let desc = formProductRequest.description;
      let docDateConvert = this.utilService.convertDate(
        formProductRequest.docDate
      );
      let needDateConvert = this.utilService.convertDate(
        formProductRequest.needDate
      );
      let proposalStartDateConvert = this.utilService.convertDate(
        this.proposalStartDate
      );
      let proposalEndDateConvert = this.utilService.convertDate(
        this.proposalEndDate
      );
      let documentDate =
        docDateConvert.years +
        "-" +
        docDateConvert.months +
        "-" +
        docDateConvert.dates;
      let dateOfNeed =
        needDateConvert.years +
        "-" +
        needDateConvert.months +
        "-" +
        needDateConvert.dates;
      
      let proposalStartDate =
        proposalStartDateConvert.years +
        "-" +
        proposalStartDateConvert.months +
        "-" +
        proposalStartDateConvert.dates;

      let proposalEndDate =
        proposalEndDateConvert.years +
        "-" +
        proposalEndDateConvert.months +
        "-" +
        proposalEndDateConvert.dates;

      let arrProduct: any = [];
      let arrQty: any = [];
      let arrUnitType: any = [];
      let arrProductType :any =[];
      let arrSource :any =[];
      let arrPrice :any =[];

      for (let x = 0; x < this.productRequestDetailList.length; x++) {
        let htmlIdQtyRequest: any = "qtyRequest_" + x;
        let qtyRequest: any = (<HTMLInputElement>(
          document.getElementById(htmlIdQtyRequest)
        )).value;
        arrProduct[x] = this.productRequestDetailList[x].product_id;
        arrQty[x] = parseInt(qtyRequest);
        arrUnitType[x] = 0;
        arrProductType[x] = this.productRequestDetailList[x].product_type;
        arrSource[x] = this.productRequestDetailList[x].source;
        arrPrice[x] = this.productRequestDetailList[x].price;
      }
      if (
        arrProduct.some((p) => !p || p === null || p === undefined || p === "")
      ) {
        this.utilService.loadingDismiss();
        this.toastCtrl
          .create({
            duration: 2000,
            message: "Terdapat produk yang belum dipilih!",
          })
          .then((t) => t.present());
        return;
      }

      const duplicateProducts = arrProduct.filter((p, i) => {
        const key = `${p}_${arrProductType[i]}`;
        return (
          arrProduct.findIndex(
            (item, index) => `${item}_${arrProductType[index]}` === key
          ) !== i
        );
      });
      if (duplicateProducts.length > 0) {
        this.utilService.loadingDismiss();
        this.toastCtrl
          .create({
            duration: 2000,
            message: "Terdapat produk yang sama (duplikat)!",
          })
          .then((t) => t.present());
        return;
      }

      if (arrQty.some((q) => isNaN(q) || q < 1)) {
        this.utilService.loadingDismiss();
        this.toastCtrl
          .create({
            duration: 2000,
            message: "Qty request minimal 1 untuk setiap produk!",
          })
          .then((t) => t.present());
        return;
      }
      let invalidPriceGroup = 0;
      if (arrPrice.some((q, index) => {
        if (isNaN(q) || q < 1) {
          invalidPriceGroup = index ;//+ 1;
          return true;
        }
        return false;
      })) {
        this.utilService.loadingDismiss();
        const product = arrProduct[invalidPriceGroup];
        this.toastCtrl
          .create({
            duration: 2000,
            message: `Price Group ${product} belum ada!`,
          })
          .then((t) => t.present());

        return;
      }

      const productRequestBundle = new ProductRequestBundle();
      productRequestBundle.productRequest.counter_id = counterId;
      productRequestBundle.productRequest.warehouse_id = warehouseId;
      productRequestBundle.productRequest.proposal_number = this.proposalNumber;
      productRequestBundle.productRequest.proposal_desc = this.proposalDesc;
      productRequestBundle.productRequest.proposal_start_date = proposalStartDate;
      productRequestBundle.productRequest.proposal_end_date = proposalEndDate;
      productRequestBundle.productRequest.doc_date = documentDate;
      productRequestBundle.productRequest.need_date = dateOfNeed;
      productRequestBundle.productRequest.desc = desc;
      productRequestBundle.productRequest.status = "0";
      productRequestBundle.productRequest.created_by = this.userProfile.username;

      productRequestBundle.productRequestDetail.product_id = arrProduct;
      productRequestBundle.productRequestDetail.qty = arrQty;
      productRequestBundle.productRequestDetail.unit = arrUnitType;
      productRequestBundle.productRequestDetail.product_type = arrProductType;
      productRequestBundle.productRequestDetail.source = arrSource;
      productRequestBundle.productRequestDetail.price = arrPrice;

      this.requestService.addRequestBundle(productRequestBundle).subscribe(
        (response) => {
          this.utilService.loadingDismiss();
          if (response.status.code === 201) {
            this.showConfirmInput();
          } else {
            this.toastCtrl
              .create({ duration: 2000, message: "Terdapat Error" })
              .then((t) => t.present());
          }
        },
        () => {
          this.utilService.loadingDismiss();
          this.toastCtrl
            .create({ duration: 2000, message: "Gagal terhubung ke server" })
            .then((t) => t.present());
        }
      );
    });
  }

  async customAlert(subHeader:any,message:any){    
    const alert = await this.alertController.create({
      header: '⚠️ Perhatian',
      subHeader: subHeader,//'Produk Reguler Belum Ada'
      message: message,//'Minimal harus ada 1 produk reguler.',
      buttons: [
        {
          text: 'OK',
          role: 'confirm'
        }
      ]
    });
    await alert.present();
  }
  async showConfirmInput() {
    const alert = await this.alertController.create({
      header: "Notification",
      cssClass: "custom-alert-class",
      message: "Data sudah tersimpan!",
      buttons: [
        {
          text: "OK",
          handler: () => {
            this.navCtrl.navigateForward(["/product-request"]);
          },
        },
      ],
    });

    await alert.present();
  }

  addDetail() {
    let length = this.productRequestDetailList.length;
    this.productRequestDetailList.push({
      id: length + 1,
      product_id: null,
      product_name: null,
      unit: null,
      product_type:this.warehouseType ? this.warehouseType : null,
      source:'I',
      price:0
    });
  }

  async findProduct(index: any) {
    const modal = await this.modalController.create({
      component: FindProductComponent,
      componentProps: {
        productList: this.productList,
      },
      backdropDismiss: false,
    });

    modal.onDidDismiss().then((modelData) => {
      let data = modelData.data;
      if (data) {
        let findProduct = this.productRequestDetailList.findIndex(
          x =>
            x.product_id === data.id &&
            x.source === 'I'
        );
        if (findProduct === -1) {
          let findPrice = this.productPriceGroup.find(x=>x.id==data.id);
          let price = 0;
          if(findPrice){
            price = findPrice.price;
          }
          this.productRequestDetailList[index].product_id = data.id;
          this.productRequestDetailList[index].product_name = data.product_name;
          this.productRequestDetailList[index].product_type = this.warehouseType=='P'?'P':data.product_type;
          this.productRequestDetailList[index].source = 'I';
          this.productRequestDetailList[index].price = price;
        }
        else{
          this.customAlert('Produk Sudah Ada','Produk tidak boleh duplikat');
        }
      }
    });

    return await modal.present();
  }

  deleteProduct(index: any) {
    this.productRequestDetailList.splice(index, 1);
  }

  public selectWarehouse(event) {
    this.warehouseId = event.value.id;
    let findWarehouse = this.warehouseList.find(x=>x.id==this.warehouseId);
    if(findWarehouse){
      this.warehouseType = findWarehouse.warehouse_type_id=='2'?'P':'R';
    }
    let findInput = this.productRequestDetailList.filter(x=>x.source=='I');
    if(findInput.length>0){
      for(let i=0;i<findInput.length;i++){
        findInput[i].product_type=this.warehouseType;
      }
    }
  }

  public selectCounter(event) {
    this.proposalNumber ='';
    this.proposalDesc ='';
    this.proposalStartDate ='';
    this.proposalEndDate ='';
    
    this.productRequestDetailList = this.productRequestDetailList.filter(
      x => x.source !== 'P'
    );
    
    this.formProductRequestCreate.patchValue({
      proposalNumber: '',
      warehouseId:''
    });
    this.counterId = event.value.id;
    let findCounter = this.counterList.find(x=>x.id==this.counterId);
    if(findCounter){
      this.counterCode = findCounter.counter_code;
    }
    this.warehouseId = "";
    let filterWarehouse = this.warehouseList.filter(
      (x) => parseInt(x.counter_id) === parseInt(this.counterId)
    );
    this.warehouseListShow = filterWarehouse;
    this.getProposal();
  }

  selectProposal(event){
    this.proposalNumber = event.value.noproposal;
    this.proposalDesc = '';
    this.proposalStartDate = '';
    this.proposalEndDate = '';
    let filterProposal = this.proposalList.find(x=>x.noproposal==this.proposalNumber);
    if(filterProposal){
      this.productRequestDetailList = this.productRequestDetailList.filter(x=>x.source=='I');
      this.proposalDesc  =filterProposal.nama_proposal;
      this.proposalStartDate  =filterProposal.periodeprogawal;
      this.proposalEndDate  =filterProposal.periodeprogakhir;
      if(filterProposal.details.length>0){
        let length = this.productRequestDetailList.length;
        for(let i=0;i<filterProposal.details.length;i++){
          let findPrice = this.productPriceGroup.find(x=>x.id==filterProposal.details[i].pcode);
          let price = 0;
          if(findPrice){
            price = findPrice.price;
          }
          this.productRequestDetailList.push({
            id: length + 1,
            product_id: filterProposal.details[i].pcode,
            qty: filterProposal.details[i].qty,
            product_name: filterProposal.details[i].nama_produk,
            unit: 'PCS',
            product_type:filterProposal.details[i].product_type ? filterProposal.details[i].product_type: 'P',
            source:'P',
            price:price
          });
        }
      }
    }
  }

  onFileChange(evt: any) {
    /* Hanya menerima satu file */
    const target: DataTransfer = <DataTransfer>evt.target;
    if (target.files.length !== 1) {
      this.toastCtrl
        .create({
          duration: 3000,
          message: "Harap unggah satu file Excel saja.",
        })
        .then((t) => t.present());
      return;
    }

    this.productRequestDetailList = [];

    this.utilService.loadingPresent("Membaca file Excel...").then(() => {
      const reader: FileReader = new FileReader();

      reader.onload = (e: any) => {
        /* Baca data workbook sebagai binary string */
        const bstr: string = e.target.result;
        const wb: XLSX.WorkBook = XLSX.read(bstr, { type: "binary" });

        /* Ambil sheet pertama */
        const wsname: string = wb.SheetNames[0];
        const ws: XLSX.WorkSheet = wb.Sheets[wsname];

        /* Konversi data sheet menjadi array JSON. header: 1 berarti baris pertama adalah data, bukan header. */
        const data = XLSX.utils.sheet_to_json(ws, { header: 1 });

        this.utilService.loadingDismiss();
        this.processExcelData(data);
      };

      reader.readAsBinaryString(target.files[0]);
    });

    if (this.fileInput) {
      setTimeout(() => {
        this.fileInput.nativeElement.value = "";
      }, 100);
    }

  }

  async processExcelData(data: any[]) {
    const detailData = data
      .slice(1)
      .filter((row) => row && row.length > 0 && String(row[0]).trim());

    if (detailData.length === 0) {
      this.toastCtrl
        .create({
          duration: 3000,
          message: "Tidak ada data produk yang valid di file Excel.",
        })
        .then((t) => t.present());
      return;
    }

    let isDataValid = true;
    let newDetailList: any[] = [];

    this.productRequestDetailList = [];

    let errorMessages: string[] = [];

    detailData.forEach((row, rowIndex) => {
      const pCode = String(row[0]).trim();
      const qtyString = String(row[1] || "0").replace(/[^0-9]/g, "");
      const qtyRequest = parseInt(qtyString, 10);

      let findPrice = this.productPriceGroup.find(x=>x.id==pCode);
      let price = 0;
      if(findPrice){
        price = findPrice.price;
      }


      const productFound = this.productList.find((p) => p.id === pCode);



      if (!pCode || isNaN(qtyRequest) || qtyRequest <= 0) {
        isDataValid = false;
        errorMessages.push(
          `<b>Baris ${rowIndex + 2}</b>: PCode atau Qty tidak valid.`
        );

        return;
      }

      const isDuplicate = this.productRequestDetailList.some(d => d.product_id === pCode) ||
                          newDetailList.some(d => d.product_id === pCode);

      if (isDuplicate) {
        isDataValid = false;
        errorMessages.push(
          `<b>Baris ${rowIndex + 2}</b>: Produk dengan PCode ${pCode} duplikat.`
        );
        return;
      }

      let detail: any = {
        id: this.productRequestDetailList.length + newDetailList.length + 1,
        product_id: pCode,
        qty: qtyRequest,
        product_type:this.warehouseType,
        source:'I',
        price:price
      };

      if (productFound) {
        detail.product_name = productFound.product_name;
      } else {
        isDataValid = false;
        errorMessages.push(
          `<b>Baris ${
            rowIndex + 2
          }</b>: Produk dengan PCode ${pCode} tidak ditemukan (Cek PCode).`
        );
        return;
      }

      newDetailList.push(detail);

      setTimeout(() => {
        const el = document.getElementById(
          "qtyRequest_" +
            (this.productRequestDetailList.length + newDetailList.length - 1)
        ) as HTMLInputElement;
        if (el) el.value = String(qtyRequest);
      }, 50);
    });

    if (!isDataValid) {
      this.productRequestDetailList = [];

      const alert = await this.alertController.create({
        header: "Import Gagal!",
        subHeader: "Harap perbaiki file Excel Anda:",
        message: `<strong>${
          errorMessages.length
        } Kesalahan Ditemukan.</strong><br><br><ul><li>${errorMessages.join(
          "</li><li>"
        )}</li></ul>`,
        buttons: ["OK"],
      });
      await alert.present();

      return;
    }

    this.productRequestDetailList =
      this.productRequestDetailList.concat(newDetailList);

    this.toastCtrl
      .create({
        duration: 3000,
        message: `${newDetailList.length} produk berhasil ditambahkan dari Excel.`,
      })
      .then((t) => t.present());
  }

  downloadTemplate() {
    const ws_data = [
      ["PCode", "Qty"],
      ["000000", 99],
      ["000000", 99],
    ];

    // Buat worksheet
    const ws: XLSX.WorkSheet = XLSX.utils.aoa_to_sheet(ws_data);

    // Buat workbook
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Detail Permintaan");

    // Simpan file
    XLSX.writeFile(wb, "Template_Permintaan_Barang.xlsx");
  }

  getProposal() {
    this.proposalList = [];
    this.deleteProposal();
    this.utilService.loadingPresent("Harap tunggu...").then(() => {
      const formProductRequest = this.formProductRequestCreate.value;
      let docDateConvert = this.utilService.convertDate(
        formProductRequest.docDate
      );
      let needDateConvert = this.utilService.convertDate(
        formProductRequest.needDate
      );      
      let documentMonth = docDateConvert.months;
      let monthOfNeed = needDateConvert.months;
      let documentYear = docDateConvert.years;
      let yearOfNeed = needDateConvert.years;
      let arrMonth = [documentMonth];
      let arrYear = [documentYear];
      
      if(documentMonth!=monthOfNeed ||  documentYear!=yearOfNeed){
        arrMonth.push(monthOfNeed);
        arrYear.push(yearOfNeed);
      }
      let totalRequest = arrMonth.length;
      let completedRequest = 0;

      for (let i = 0; i < arrMonth.length; i++) {
        let options = {
          token: this.token,
          month: arrMonth[i],
          year: arrYear[i],
          kdcounter: this.counterCode,
          counterId: this.counterId
        };

        this.requestService.apiProposal(options).subscribe(
          (response) => {
            if (response.status.code === 200) {
              this.productPriceGroup = response.mst_product;
              const newData = response.results.data
                .filter(x => !this.usedProposalList.includes(x.noproposal))
                .map(x => ({
                  ...x,
                  proposal_display: x.noproposal + ' - ' + x.nama_proposal
                }));
                for (let j = 0; j < newData.length; j++) { this.proposalList.push(newData[j]); }
            }

            completedRequest++;

            if (completedRequest === totalRequest) {
              this.utilService.loadingDismiss();
            }
          },
          () => {
            completedRequest++;

            if (completedRequest === totalRequest) {
              this.utilService.loadingDismiss();
            }

            this.toastCtrl
              .create({
                duration: 2000,
                message: "Gagal terhubung ke server"
              })
              .then((t) => t.present());
          }
        );
      }
    });
  }
  
  deleteProposal(){
    this.formProductRequestCreate.patchValue({
      proposalNumber: ''
    });
    this.proposalNumber='';
    this.proposalDesc='';
    this.proposalStartDate='';
    this.proposalEndDate='';
    this.productRequestDetailList = this.productRequestDetailList.filter(
      x => x.source !== 'P'
    );
  }
}